module.exports = __webpack_public_path__ + "static/media/cut_scrape.d8e0a944.svg";